import { useEffect, useState } from 'react';
import { CloseIcon, TaboolaLogoIcon } from 'tuui';
import { Button } from 'tuui';
import { POST_MESSAGES_TYPES } from 'modules/codeless-events/consts/iframeParentConstants';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { STEP_IDS } from '../../config/stepIds';
import { useButtonHighlighter } from '../../hooks/useButtonHighlighter';
import { useConversionActions } from '../../hooks/useConversionActions';
import { useHandleButtonAnalyzerClick } from '../../hooks/useHandleButtonAnalyzerClick';
import { useHandleFinishSelection } from '../../hooks/useHandleFinishSelection';
import styles from './buttonAnalyzer.module.scss';

export const ButtonAnalyzer = ({
    currentConversion,
    navigateToStepId,
    updateDraftEvent,
    handleCancelWizard,
    setFocusedConversionId,
}) => {
    const [isHighlighting, setIsHighlighting] = useState(true);
    const [selectedButtons, setSelectedButtons] = useState(currentConversion?.trackedElements ?? []);
    const { isEventNew } = useConversionActions();

    const handleButtonClick = useHandleButtonAnalyzerClick({
        currentConversion,
        updateDraftEvent,
        selectedButtons,
        setSelectedButtons,
        setFocusedConversionId,
    });

    const { handleFinishSelection } = useHandleFinishSelection({
        currentConversion,
        updateDraftEvent,
        selectedButtons,
        setIsHighlighting,
        navigateToStepId,
    });

    const { clearHighlights } = useButtonHighlighter({ isHighlighting, onButtonClick: handleButtonClick });
    useEffect(() => () => clearHighlights(), [clearHighlights]);

    if (!isHighlighting) {
        return null;
    }

    const handleGoBack = () => {
        if (!navigateToStepId) {
            return;
        }
        setIsHighlighting(false);

        if (updateDraftEvent) {
            updateDraftEvent(draft => ({
                ...draft,
                trackedElements: [],
            }));
        }

        window.parent.postMessage({ type: POST_MESSAGES_TYPES.FINISH_NAVIGATE }, '*');

        if (isEventNew(currentConversion.id)) {
            navigateToStepId(STEP_IDS.CONVERSION_TYPE_SETUP);
            return;
        }

        handleCancelWizard();
        navigateToStepId(STEP_IDS.VIEW_EVENTS_LIST);
    };

    return (
        <div className={styles['container']}>
            <TaboolaLogoIcon className={styles['logo-icon']} />
            <FormattedMessage
                id="codeless.buttons.analyzer.text"
                className={styles['text']}
                defaultMessage="Select one or more of the highlighted buttons to setup the event, then click 'finish selection'"
            />

            <Button
                variant={Button.variant.primary}
                size={Button.size.md}
                onClick={handleFinishSelection}
                className={styles['finish-button']}
                disabled={selectedButtons.length === 0}
            >
                <FormattedMessage id="codeless.button.analyzer.finish" defaultMessage="Finish Selection" />
            </Button>

            <CloseIcon onClick={handleGoBack} className={styles['close-icon']} />
        </div>
    );
};
